module.exports = __webpack_public_path__ + "static/media/as.8f858822.png";